import 'slick-carousel'
import jQuery from 'jquery'

export default class Carousel {
  constructor () {
    // array of all sliders on the page
    this.sliders = [...document.getElementsByClassName('js-carousel')];

    if (!this.sliders) {
      return;
    }

    // object which contains different settings for the carousel
    this.setting = {
      accessibility: true,
      focusOnSelect: true,
      swipeToSlide: true,
      centerMode: false,
      slidesToShow: 1,
      infinite: false,
      dots: true,
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Volgende slide" type="button" aria-disabled="false"><i class="icon-arrow-right" aria-hidden="true"></i><span class="sr-only">Volgende slide</span></button>',
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Vorige slide" type="button" aria-disabled="true"><i class="icon-arrow-left" aria-hidden="true"></i><span class="sr-only">Vorige slide</span></button>',

      customPaging: function(slider, i) {
        return '<button tabindex="0" type="button" role="tab" aria-label="To slide ' + (i + 1) + ' of ' + slider.slideCount + '"><span class="sr-only">To slide ' + (i + 1) + ' of ' + slider.slideCount + '</span></button>';
      },

      responsive: [
        {
          breakpoint: 1400,
          settings: {
            centerPadding: '2000px',
            centerMode: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '27px',
            centerMode: false,
            slidesToShow: 1.25,
          }
        }
      ]
    },

    this.init()
  }

  /**
   * Init all sliders.
   */
  init () {
    this.sliders.forEach((slider) => {
      const settings = {
        ...this.setting,
        appendArrows: slider,
      };

      this.setSlick(slider, settings);
    });
    if (jQuery(window).width() > 767) {
      if (jQuery('.anchorlinks').hasClass('slick-initialized')) {
        jQuery('.anchorlinks').slick('unslick');
      }
    }
  }

  /**
   * Initiaze single slick.
   *
   * @param slider
   * @param settings
   */
  setSlick (slider, settings) {
    jQuery(slider).slick(settings);
  }
}
